import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';
import { EnOnlyNote } from './EnOnlyNote';
import { useChromeT } from '../lib/i18n';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const [lang, t] = useChromeT();
  const note = t('en_only_note');
  // Spanish labels are longer: keep the compact menu until wide screens
  const bp = lang === 'es'
    ? { desktop: 'hidden xl:flex', mobile: 'xl:hidden' }
    : { desktop: 'hidden md:flex', mobile: 'md:hidden' };

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/protection-center" className="flex items-center" data-testid="header-logo-link">
            <Logo size="default" />
          </Link>

          {/* Desktop Navigation */}
          <nav className={`${bp.desktop} items-center space-x-8`}>
            <Link
              to="/protection-center"
              data-testid="nav-protection-center"
              className={`font-semibold transition-colors ${
                isActive('/protection-center') ? 'text-accent-orange' : 'text-header-text hover:text-accent-orange'
              }`}
            >
              {t('nav_protection_center')}<EnOnlyNote text={note} />
            </Link>
            <Link
              to="/services"
              data-testid="nav-services"
              className={`font-medium transition-colors ${
                isActive('/services') ? 'text-accent-orange' : 'text-header-text hover:text-accent-orange'
              }`}
            >
              {t('nav_services')}<EnOnlyNote text={note} />
            </Link>
            <Link
              to="/about"
              data-testid="nav-about"
              className={`font-medium transition-colors ${
                isActive('/about') ? 'text-accent-orange' : 'text-header-text hover:text-accent-orange'
              }`}
            >
              {t('nav_about')}<EnOnlyNote text={note} />
            </Link>
            <Link
              to="/protection-center#contact"
              data-testid="nav-contact"
              className="font-medium transition-colors text-header-text hover:text-accent-orange"
            >
              {t('nav_contact')}<EnOnlyNote text={note} />
            </Link>
            <Link
              to="/protection-center#what-to-protect"
              data-testid="nav-cta-start-profile"
              className="btn-primary"
            >
              {t('nav_cta')}<EnOnlyNote text={note} />
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className={`${bp.mobile} text-header-text`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className={`${bp.mobile} py-4 border-t`}>
            <div className="flex flex-col space-y-4">
              <Link
                to="/protection-center"
                data-testid="nav-mobile-protection-center"
                className="text-header-text hover:text-accent-orange font-semibold transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav_protection_center')}<EnOnlyNote text={note} />
              </Link>
              <Link
                to="/services"
                data-testid="nav-mobile-services"
                className="text-header-text hover:text-accent-orange transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav_services')}<EnOnlyNote text={note} />
              </Link>
              <Link
                to="/about"
                data-testid="nav-mobile-about"
                className="text-header-text hover:text-accent-orange transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav_about')}<EnOnlyNote text={note} />
              </Link>
              <Link
                to="/protection-center#contact"
                data-testid="nav-mobile-contact"
                className="text-header-text hover:text-accent-orange transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav_contact')}<EnOnlyNote text={note} />
              </Link>
              <Link
                to="/protection-center#what-to-protect"
                data-testid="nav-mobile-cta-start-profile"
                className="btn-primary inline-block w-fit"
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav_cta')}<EnOnlyNote text={note} />
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
